import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    users: 0,
    mentors: 0,
    investors: 0,
    proUsers: 0,
    revenue: 0,
  });

  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const loadStats = async () => {
      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        const [usersRes, billingRes] = await Promise.all([
          axios.get("/api/admin/users", { headers }),
          axios.get("/api/billing/transactions", { headers }),
        ]);

        const users = Array.isArray(usersRes.data)
          ? usersRes.data
          : usersRes.data?.users || [];

        const transactions = Array.isArray(billingRes.data)
          ? billingRes.data
          : billingRes.data?.transactions || [];

        const revenue = transactions.reduce(
          (sum, t) => sum + (t.amount || 0),
          0
        );

        setStats({
          users: users.length,
          mentors: users.filter(u => u.role === "mentor").length,
          investors: users.filter(u => u.role === "investor").length,
          proUsers: users.filter(u => u.plan === "pro").length,
          revenue,
        });
      } catch (err) {
        console.error("Admin stats load failed", err);
      }
    };

    loadStats();
  }, []);

  const cards = [
    {
      title: "User Management",
      subtitle: `${stats.users} users`,
      color: "bg-blue-600",
      onClick: () => navigate("/admin/users"),
    },
    {
      title: "Pricing & Plans",
      subtitle: `${stats.proUsers} Pro users`,
      color: "bg-purple-600",
      onClick: () => navigate("/admin/pricing"),
    },
    {
      title: "Billing & Revenue",
      subtitle: `₹${stats.revenue}`,
      color: "bg-green-600",
      onClick: () => navigate("/admin/billing"),
    },
  ];

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-6">👑 Admin Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map((c, i) => (
          <div
            key={i}
            onClick={c.onClick}
            className={`${c.color} text-white rounded-xl p-6 cursor-pointer shadow-lg hover:scale-[1.02] transition`}
          >
            <h2 className="text-xl font-bold">{c.title}</h2>
            <p className="mt-2 text-sm opacity-90">{c.subtitle}</p>
            <p className="mt-4 underline text-sm">Open →</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
